import { FieldError } from '~/components/ui/field';

type InputErrorProps = {
  error: string;
};

export default function InputError({ error }: InputErrorProps) {
  return <FieldError className="mt-1">{error}</FieldError>;
}
